import { CoreIcon } from '../core-icon';
import chevronLeftSVG from '../../assets/icons/chevron-left.svg';
import type { IconProps } from '../core-icon';

export const ChevronLeftIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronLeftSVG} {...props} />;
};
